import React from "react";
import "../PagesCss/AreasAtuacao.css";
import BotaoWhatsapp from "../../component/BotaoWhatsapp";
import CTAWhatsapp from "../../component/CTAWhatsapp";

function RenegociacaoDividasRurais() {
  return (
    <section className="area-page">
      <h1>Renegociação de Dívidas Rurais</h1>

      <p>
        A Súmula 298 do Superior Tribunal de Justiça estabelece que "o
        alongamento de dívida originada em crédito rural não constitui faculdade
        da instituição financeira, mas direito do devedor, nos termos da lei".
      </p>

      <p>
        Isso significa dizer que, desde que o produtor rural cumpra os
        requisitos legais, as instituições financeiras não podem se negar a
        alongar, ou seja, literalmente "esticar" o prazo de pagamento da dívida,
        dividindo-a em mais parcelas e com um prazo de carência de até dois anos
        para o pagamento da primeira parcela da renegociação, tudo isso sem
        aumentar as taxas e encargos do contrato original e também sem a
        incidência de juros e multa por inadimplência, mantendo o nome do
        produtor rural "limpo" nos órgãos de proteção ao crédito (SPC, Serasa,
        etc.).
      </p>

      <p>
        Se você quer descobrir se tem direito de pedir o alongamento da sua
        dívida, clique no botão abaixo para falar gratuitamente com nossos
        especialistas, direto no seu WhatsApp.
      </p>

      <CTAWhatsapp text="Fale com um especialista" />

      <BotaoWhatsapp />
    </section>
  );
}

export default RenegociacaoDividasRurais;
